module.exports = "//d274d294w9cx2v.cloudfront.net/99c36d953449a0d352ebd5f9d47864e48aae461c/images/photo-couple-wide.png";